<template lang="pug">
    .authentication-form
        transition(name="slide-vertical")
            .notification.is-danger.is-light(v-if="error")
                button.delete(type="button" @click="error = false")
                | {{ error }}
        .notification.is-info.is-light(v-if="password.success")
            button.delete(type="button" @click="password.success = false; tab = 'signin'")
            | {{ password.success }}
        validation-observer(v-else v-slot="{ invalid }" ref="form")
            h4.subtitle.is-4 Neues Passwort festlegen
            form(@submit.prevent="submit")
                .panel
                    loading(:active="loading" :is-full-page="false" :height="40" :width="40" color="#084375")
                    .box
                        .field
                            validation-provider(name="Passwort" rules="required|password:@score" v-slot="{ errors }")
                                label.label(for="password") Passwort
                                .control.has-icons-right
                                    input#password.input(
                                        :type="password.type"
                                        name="password"
                                        v-model="form.password"
                                        :class="{ 'is-danger': errors && errors.length }"
                                    )
                                    button.icon.is-small.is-right(
                                        v-if="form.password && password.type === 'password'"
                                        type="button" @click="password.type = 'text'"
                                    )
                                        i.far.fa-eye
                                    button.icon.is-small.is-right(
                                        v-else-if="form.password && password.type === 'text'"
                                        type="button" @click="password.type = 'password'"
                                    )
                                        i.far.fa-eye-slash
                                    span.icon.is-small.is-right(v-else)
                                        i.fas.fa-key
                                password(
                                    v-model="form.password"
                                    :strength-meter-only="true"
                                    @score="score => password.score = score"
                                    @feedback="passwordFeedback"
                                )
                                p.help.is-danger(v-if="password.warning || (errors && errors.length)") {{ password.warning || errors[0] }}
                                p.help.has-text-grey(v-else) Pflicht
                            validation-provider(name="score")
                                input#password-score(type="hidden" name="password-score" v-model.number="password.score")
                    .buttons.is-pulled-right
                        .control
                            button.button.is-primary(type="submit" :disabled="invalid") speichern
                    .is-clearfix
</template>

<script>

import Vue from 'vue';
import store from '@/store'

import { mapGetters } from 'vuex'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

import Password from 'vue-password-strength-meter'
import Loading from 'vue-loading-overlay'

import { translateWarnings, translateSuggestion } from '@/validation';

let timeout;
export default {
    name: 'PasswordResetForm',
    data() {
        let data = {
            error: false,
            loading: false,
            form: {
                password: '',
            },
            password: {
                type: 'password',
                score: 0,
                warning: false,
                success: false,
                suggestions: [],
            },
        }

        return data
    },
    components: {
        Loading,
        Password,
        ValidationObserver,
        ValidationProvider,
    },
    computed: {
        email() {
            return this.$route.params.email
        },
        token() {
            return this.$route.params.token
        },
        ...mapGetters({
            recaptchaSiteKey: 'googleRecaptchaSiteKey',
            cms: 'CMS',
        }),
    },
    methods: {
        async submit() {
            this.error = false
            this.loading = true
            if (timeout) clearTimeout(timeout)

            const valid = await this.$refs.form.validate()
            if (valid && this.recaptchaSiteKey) {
                await this.$recaptchaLoaded()
                try {
                    const token = await this.$recaptcha('auth')

                    const payload = {
                        email: this.email,
                        token: this.token,
                        cms_id: parseInt(this.cms.id),
                        password: this.form.password,
                    }
                    store.dispatch('auth/resetPassword', payload)
                        .then(data => {
                            this.password.success = 'Ihr Passwort wurde geändert. Sie können sich jetzt mit dem neuen Passwort anmelden.'
                            this.form.password = ''
                        })
                        .catch(error => {
                            this.error = 'Es gibt ein technisches Problem. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
                            timeout = setTimeout(() => this.error = false, 6000)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } catch (error) {
                    console.error(error);
                    this.error = 'Es gibt ein technisches Problem. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
                    timeout = setTimeout(() => this.error = false, 6000)
                    this.loading = false
                }
            } else {
                // TODO
                // submit without recaptcha ?

                this.error = 'Es gibt ein technisches Problem. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
                this.loading = false
                timeout = setTimeout(() => this.error = false, 6000)
            }
        },
        passwordFeedback(feedback) {
            // translateSuggestion
            this.password.warning = translateWarnings(feedback.warning)
        }
    },
    beforeMount() {
        if (this.recaptchaSiteKey) {
            Vue.use(VueReCaptcha, { siteKey: this.recaptchaSiteKey })
        }
    }
}

</script>

<style lang="sass" scoped></style>
